// 라우트 → GA4 페이지 컨텍스트 정규화 (설계 §6). 실제 ID·쿼리·해시는 절대 포함하지 않는다.
type ToLike = { path: string; matched: { path: string }[]; meta?: { title?: unknown; subTitle?: unknown } }

const NOT_FOUND_ROUTE = '/:pathMatch(.*)*'

// vue-router 의 matched 마지막 레코드 path = 라우트 템플릿 (예 /order-list/:id)
export function routePattern(to: ToLike): string {
  const matched = to && to.matched ? to.matched : []
  const last = matched.length ? matched[matched.length - 1].path : ''
  if (!last) return '/unknown'
  if (last === NOT_FOUND_ROUTE) return '/not-found'
  return last
}

// LNB 1뎁스 그룹. prefix 는 route_pattern 기준 (설계 §6.3). 끝이 '-' 인 prefix 는 startsWith 로만 판정.
const GROUPS: [string, string[]][] = [
  ['대시보드', ['/dashboard']],
  [
    '상품',
    ['/product-list', '/product/create', '/product/price', '/product/display', '/connect-category', '/connect-product', '/codi-list'],
  ],
  ['주문', ['/order-list', '/cancel-list', '/order-helpi', '/order-brandi', '/shipping-policy']],
  ['프로모션', ['/promotion', '/coupon']],
  ['문의리뷰', ['/qna', '/review']],
  ['정산', ['/partner-payout', '/partner-payout-rehabilitationclaim', '/ledgers', '/sales-vat', '/creditor', '/rehabilitation-']],
  ['통계', ['/report']],
  ['공지', ['/notice']],
  ['설정', ['/settings', '/penalty', '/download', '/policy']],
  ['도매', ['/wholesale']],
  ['시스템', ['/not-authorized', '/maintenance', '/not-found']],
]

function matchesPrefix(pattern: string, prefix: string): boolean {
  if (prefix.charAt(prefix.length - 1) === '-') return pattern.indexOf(prefix) === 0
  return pattern === prefix || pattern.indexOf(prefix + '/') === 0
}

export function pageGroup(pattern: string): string {
  for (const [group, prefixes] of GROUPS) {
    if (prefixes.some((p) => matchesPrefix(pattern, p))) return group
  }
  if (process.env.NODE_ENV !== 'production') console.warn('[analytics] page_group 매핑 없음:', pattern)
  return '기타'
}

const TITLE_FALLBACK: Record<string, string> = { '/not-authorized': '권한없음', '/not-found': '페이지없음', '/maintenance': '점검' }

export function pageTitle(to: ToLike, pattern: string): string {
  const meta = (to && to.meta) || {}
  const title = typeof meta.title === 'string' ? meta.title : ''
  const sub = typeof meta.subTitle === 'string' ? meta.subTitle : ''
  if (title) return sub ? `${title} - ${sub}` : title
  return TITLE_FALLBACK[pattern] || '기타'
}

export function safeUrl(origin: string, pattern: string): string {
  return `${origin}${pattern}`
}

// 발화하지 않는 라우트. /logout 은 logout 이벤트가 대체한다.
const EXCLUDED = ['/ping', '/playground', '/logout']
export function isExcluded(pattern: string): boolean {
  return EXCLUDED.indexOf(pattern) >= 0
}

// 첫 진입 referrer 는 origin 까지만 (외부 사이트의 경로·쿼리를 싣지 않는다)
export function referrerOrigin(ref: string): string {
  try {
    return ref ? new URL(ref).origin : ''
  } catch (e) {
    return ''
  }
}
